/**
 * User: jv
 * Date: 12/05/16
 * Time: 12:56
 */
const utils = require("Sources/utils/utils");
const log = require("Sources/utils/logger")();
const CONSTANTS = require("Sources/config/constants");
const localeReq = require.context("Localization", true, /\.json$/);

let LanguageManager = {};

((LanguageManager) =>
{
    let locale = null;
    let localeMap = null;

    LanguageManager.init = function()
    {
        localStorage.removeItem("locale");
        // locale = sessionStorage.getItem("locale");

        let tmpLocale = utils.getQueryParam("locale");
        if (!utils.isNullOrEmpty(tmpLocale))
        {
            locale = tmpLocale;
            // sessionStorage.setItem("locale", locale);
        }

        if (utils.isNullOrEmpty(locale) || !localeExists(locale))
        {
            locale = CONSTANTS.DEFAULT_LOCALE;
        }

        $("html").addClass(locale);

        _init();
    };

    function _init()
    {
        getLocaleMap();
        applyLocale();
        $(".page-wrapper").show();

        if (utils.isFunction(LanguageManager.onInit))
        {
            LanguageManager.onInit();
        }

        if (utils.isFunction(LanguageManager.onInitGlobal))
        {
            LanguageManager.onInitGlobal();
        }
    }

    LanguageManager.onInit = null;

    LanguageManager.onInitGlobal = null;

    LanguageManager.changeLocale = function(newLocale)
    {
        if (localeExists(newLocale))
        {
            $("html").removeClass(locale).addClass(newLocale);
            locale = newLocale;
            // sessionStorage.setItem("locale", locale);
            LanguageManager.localize();
        }
        else
        {
            throw "Locale does not exist";
        }
    };

    LanguageManager.getCurrentLocale = function()
    {
        return locale;
    };

    LanguageManager.localize = function()
    {
        if (!localeMapIsDefined() || locale !== localeMap.locale)
        {
            getLocaleMap();
            applyLocale();
        }
        else
        {
            applyLocale();
        }
    };

    function getLocaleMap()
    {
        try
        {
            log.info("Trying to fetch locale '%s'", locale);

            let localeRequire = "./" + locale + ".json";

            log.info("'%s' is in %o ? %s", localeRequire, localeReq.keys(), $.inArray(localeRequire, localeReq.keys()) !== -1);

            if ($.inArray(localeRequire, localeReq.keys()) !== -1)
            {
                let tmpLocaleMap = localeReq(localeRequire);

                log.info("Successfully fetched locale map for locale [%s]: %o", locale, tmpLocaleMap);

                localeMap = tmpLocaleMap;
            }
            else if (locale !== "en-GB" && $.inArray("./en-GB.json", localeReq.keys()) !== -1)
            {
                $("html").removeClass(locale).addClass("en-GB");
                locale = "en-GB";
                // sessionStorage.setItem("locale", locale);
                getLocaleMap(callback);
            }
            else
            {
                log.error("Couldn't find locale [%s] in known locale list: %o", locale, localeReq.keys());
                alert("Localisation could not be loaded, contact your site administrator.");
            }
        }
        catch (e)
        {
            console.error(e);
        }
    }

    LanguageManager.localeExists = function(locale)
    {
        return localeExists(locale);
    }
    
    function localeExists(pLocale)
    {
        let localeRequire = "./" + pLocale + ".json";

        return $.inArray(localeRequire, localeReq.keys()) !== -1;
    }

    LanguageManager.applyLocale = function(selector)
    {
        if (localeMapIsDefined() && locale === localeMap.locale)
        {
            // Add back to include the selector itself
            applyLocale($(selector).find("[data-localize]").addBack(selector).filter("[data-localize]"));
        }
    };

    function applyLocale($element)
    {
        $element = utils.isNotNull($element) ? $element : $("[data-localize]");

        $element.each(function()
        {
            let element = $(this);
            let key = $(this).data("localize");

            if (typeof localeMap === "object" && localeMap.localization.hasOwnProperty(key))
            {
                changeTextOrPlaceholder(element, LanguageManager.getValueForKey(key));
            }
            else
            {
                changeTextOrPlaceholder(element, key);
            }
        });
    }

    function changeTextOrPlaceholder(element, text)
    {
        if (element.is("input") || element.is("textarea"))
        {
            //element.attr("placeholder", text.toLowerCase());
            element.attr("placeholder", text);
        }
        else
        {
            replaceNodeText(element, text);
        }
    }

    function replaceNodeText(element, text)
    {
        element.html(text);
    }

    LanguageManager.getValueForKey = function(key)
    {
        if (localeMapIsDefined() && localeMap.localization.hasOwnProperty(key))
        {
            let result = localeMap.localization[key];
            result = result.replaceAll("{next-icon}", "<i class='fa fa-angle-double-right'></i>");
            return result;
        }
        else
        {
            return key;
        }
    };

    function localeMapIsDefined()
    {
        return utils.isObject(localeMap) && localeMap.hasOwnProperty("locale") && localeMap.hasOwnProperty("localization");
    }
})(LanguageManager);

// Expose the Language manager to the window, this will be available as soon as the Language manager is accessed the first time (when a game is loaded)
/* Use this code in the console to cycle between all languages on a 3 second delay

["en-GB","nl-BE","it-IT","et-EE","de-DE","es-ES","pt-PT","si-SI","fi-FI","ba-BA","rs-RS","hr-HR","se-SE","pl-PL","gr-GR","cz-CZ","fr-FR","lv-LV","jp-JP"].forEach((element, index) => {
    setTimeout(() => {
        LanguageManager.changeLocale(element);
    }, 3000 * index);
});

* */
window.LanguageManager = LanguageManager;


module.exports = LanguageManager;



// WEBPACK FOOTER //
// ./app/js/services/language-manager.js